import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';

// Por que ainda não dá para agendar nem enviar (null = pode)
export const sendBlockReason = ({ subject, itemCount, blockedCount }) => {
  if (itemCount === 0) return 'Adicione ao menos um item';
  if (!String(subject || '').trim()) return 'Preencha o assunto';
  if (blockedCount > 0) return 'Tire ou espere os itens aguardando deploy';
  return null;
};

const WithTooltip = ({ title, children }) => (
  title ? <Tooltip title={title}><span>{children}</span></Tooltip> : children
);

/**
 * Rodapé do editor de envio. Toda ação grava antes as mudanças pendentes.
 * @param {{ edition: Object, blockReason: string|null, busy: boolean, isSaving: boolean,
 *   isSendingPreview: boolean, onCancelEdition, onPreview, onSendPreview, onSchedule,
 *   onUnschedule, onSendNow, onSave: Function }} props
 */
function EditionEditorActions({
  edition, blockReason, busy, isSaving, isSendingPreview,
  onCancelEdition, onPreview, onSendPreview, onSchedule, onUnschedule, onSendNow, onSave,
}) {
  const disabled = busy || isSaving;
  const scheduled = edition.status === 'scheduled';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', width: '100%' }}>
      <Button color="error" onClick={onCancelEdition} disabled={disabled}>Cancelar envio</Button>
      <Box sx={{ flex: 1 }} />
      <Button startIcon={<VisibilityOutlinedIcon />} onClick={onPreview} disabled={disabled}>Prévia</Button>
      <Button startIcon={<ForwardToInboxOutlinedIcon />} onClick={onSendPreview} disabled={disabled || isSendingPreview}>
        {isSendingPreview ? 'Enviando...' : 'Enviar prévia'}
      </Button>
      {scheduled ? (
        <Button variant="outlined" startIcon={<ScheduleOutlinedIcon />} onClick={onUnschedule} disabled={disabled}>Desagendar</Button>
      ) : null}
      <WithTooltip title={blockReason}>
        <Button variant="outlined" startIcon={<ScheduleOutlinedIcon />} onClick={onSchedule} disabled={disabled || Boolean(blockReason)}>
          {scheduled ? 'Mudar horário' : 'Agendar'}
        </Button>
      </WithTooltip>
      <WithTooltip title={blockReason}>
        <Button variant="outlined" color="warning" startIcon={<SendOutlinedIcon />} onClick={onSendNow} disabled={disabled || Boolean(blockReason)}>
          Enviar agora
        </Button>
      </WithTooltip>
      <Button variant="contained" onClick={onSave} disabled={disabled}>
        {isSaving ? 'Salvando...' : 'Salvar'}
      </Button>
    </Box>
  );
}

export default EditionEditorActions;
